import { Avatar, Box, IconButton } from '@mui/material';
import { FaBars, FaWhatsapp } from 'react-icons/fa6';
import ImageNavigation from '../ImageNavigation';
import { header_content } from '../../../../../data/general_texts';
import { useAuth } from '../../../../../contexts/AuthProvider';
import { Link } from 'react-router-dom';
import { getGreetingInitial, getGreetingName } from '../../partnerNav';
import NotificationsBell from '../NotificationsBell';

const MainLinksMobile = ({ toggleDrawer }) => {
    const { isAuthenticated, user, userName } = useAuth();
    const greetName = getGreetingName(user, userName);

    return (
        <Box sx={styles.main_links_mobile}>
            <IconButton
                onClick={toggleDrawer(true)}
                aria-label="Abrir menu"
                sx={styles.icon}
            >
                <FaBars size={22} />
            </IconButton>
            <ImageNavigation />
            {isAuthenticated ? (
                <Box sx={styles.rightActions}>
                    <NotificationsBell size={18} />
                    <IconButton
                        component={Link}
                        to="/meu-perfil"
                        aria-label="Meu perfil"
                        sx={{ p: 0.5 }}
                    >
                        <Avatar src={user?.image || undefined} alt={greetName} sx={styles.avatar}>
                            {getGreetingInitial(greetName)}
                        </Avatar>
                    </IconButton>
                </Box>
            ) : (
                <IconButton
                    href={header_content.promotion_banner_content.cta_link}
                    target="_blank"
                    rel="noopener noreferrer"
                    aria-label="Falar com a Inovart no WhatsApp"
                    sx={styles.icon}
                >
                    <FaWhatsapp size={24} />
                </IconButton>
            )}
        </Box>
    );
};

const styles = {
    main_links_mobile: {
        display: {
            xs: 'flex',
            md: 'none',
        },
        justifyContent: 'space-between',
        alignItems: 'center',
        px: 0.5,
        py: 0.75,
        minHeight: '3.5rem',
    },
    rightActions: {
        display: 'flex',
        alignItems: 'center',
        gap: 0.25,
    },
    icon: {
        color: 'common.white',
        p: 1.25,
    },
    avatar: {
        width: 32,
        height: 32,
        fontSize: '0.75rem',
        fontWeight: 600,
        bgcolor: 'secondary.main',
        color: 'primary.main',
    },
};

export default MainLinksMobile;
